import React, { useState, useCallback } from 'react';
import { Row, Col, Steps, Input, Select, Radio, Form } from 'antd';
import { get } from 'lodash';
import { FormContext } from '../../context';
import { getMetricInfo } from '../../../constants';
import { FORM_HELP } from '../../constants';
import { HoursInDay } from './components';

const { Option } = Select;

const Advanced = ({ form }) => {
  const { setFieldsValue } = form;
  const { alert } = React.useContext(FormContext);
  const { metric, samples } = alert;
  const metricsInfo = getMetricInfo();
  const metricInfo = metricsInfo[metric];
  const [custom, setCustom] = useState(metricInfo.cm_value === samples ? 0 : 1);

  const onCustomChange = useCallback(
    (v) => {
      setCustom(v);
      if (v === 0) {
        setFieldsValue({ samples: metricInfo.cm_value });
      }
    },
    [setCustom, setFieldsValue, metricInfo.cm_value],
  );

  return (
    <>
      <Row style={{ margin: '12px 0px' }}>
        <Steps current={1} items={[{ title: 'General' }, { title: 'Advanced' }]} />
      </Row>

      <Form layout="vertical" form={form}>
        <Row gutter={8}>
          <Col span={8}>
            <Form.Item label="Sample Traffic Volume">
              <Select defaultValue={custom} onChange={onCustomChange}>
                <Option value={0}>Recommended</Option>
                <Option value={1}>Custom</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="  " name="samples" initialValue={get(alert, 'samples', 60)}>
              <Input disabled={custom === 0} addonAfter={metricInfo.cm_label} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Cooldown"
          tooltip={FORM_HELP.cooldown}
          name="cooldown"
          initialValue={get(alert, 'cooldown', 60)}
        >
          <Select>
            <Option value={0}>0</Option>
            <Option value={15}>15 Minutes</Option>
            <Option value={30}>30 Minutes</Option>
            <Option value={45}>45 Minutes</Option>
            <Option value={60}>1 Hour</Option>
            <Option value={120}>2 Hours</Option>
            <Option value={180}>3 Hours</Option>
            <Option value={360}>6 Hours</Option>
            <Option value={720}>12 Hours</Option>
            <Option value={1440}>24 Hours</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Priority" name="priority" initialValue={get(alert, 'priority', 3)}>
          <Select>
            <Option value={0}>P1</Option>
            <Option value={1}>P2</Option>
            <Option value={2}>P3</Option>
            <Option value={3}>Not Set</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Hours In Day"
          name="lifespan"
          initialValue={get(alert, 'lifespan', {})}
          tooltip={FORM_HELP.hoursInDay}
        >
          <HoursInDay />
        </Form.Item>

        <Form.Item
          label="Notification Format"
          name="attachment"
          initialValue={get(alert, 'attachment', false)}
          tooltip={FORM_HELP.format}
        >
          <Radio.Group>
            <Radio value={false}>Email Only</Radio>
            <Radio value={true}>Email and JSON</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </>
  );
};

export default Advanced;
